import { EventEmitter, Input, Output } from "@angular/core";
import { Component } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { reorderArray } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { Utilities } from "../../providers/utilities";

@Component({
  selector: "app-event-staff-agenda",
  templateUrl: "event-staff-agenda.html",
})
export class EventStaffAgendaComponent {

  @Input() public speakers: any;
  @Input() public clientId: string;
  @Input() public eventId: string;
  @Output() public emitSpeaker = new EventEmitter();
  @Output() public emitSpeakers = new EventEmitter();

  public submitAttempt: boolean = false;
  public form: FormGroup;
  public staff$: Observable<any[]>;
  public isReorder = false;
  public isForm = false;
  public currentSpeaker = null;

  constructor(
    private utilities: Utilities,
  ) { }

  public reorderItems(indexes) {
    const load = this.utilities.setLoading();

    return Promise.resolve()
      .then(() => reorderArray(this.speakers, indexes))
      .then((newSpeakers) => newSpeakers.map((item, key) => ({ ...item, order: key })))
      .then((newSpeakers) => this.emitSpeakers.emit(newSpeakers))
      .then(() => load.dismiss());
  }

  public addOrUpdate(current = null) {
    const load = this.utilities.setLoading();

    return Promise.resolve()
      .then(() => {
        if (current) {
          this.currentSpeaker = current;
        } else {
          this.currentSpeaker = null;
        }
        return true;
      })
      .then(() => this.isForm = true)
      .then(() => load.dismiss());
  }

  public createOrUpdateSpeaker(speaker) {
    const load = this.utilities.setLoading();
    return Promise.resolve()
      .then(() => this.emitSpeaker.emit(speaker))
      .then(() => this.isForm = false)
      .then(() => load.dismiss());
  }
}



// WEBPACK FOOTER //
// ./src/components/event-staff-agenda/event-staff-agenda.ts